import React from 'react'
import { LanguageConsumer } from './lib/LanguageContext'
import './Footer.css'
import Logo from './images/index.png'
import { Link } from 'react-router-dom'


const Footer = props => 
  <LanguageConsumer>
    {({polyglot}) =>
        (<div className='Footer'>
            <span className='FooterInfo'>
                <div className='footerInfo-header'>
                    <h4>{polyglot.t('help')}</h4>
                </div>
                <div className='footer-item'>
                    <span className='fas fa-book footerInfo-icon'> </span>
                    <Link to='/help'>{polyglot.t('usersGuide1')}</Link>
                </div>
                <div className='footerInfo-header'>
                    <h4>{polyglot.t('contact')}</h4>
                </div>
                <div className='footer-item'>
                    <span className='fas fa-mouse-pointer footerInfo-icon'></span>
                    <h4>{polyglot.t('web')}</h4>: <a href='https://www.gunet.gr' target="_blank"  rel="noopener noreferrer">https://www.gunet.gr</a>
                </div>
                <div className='footer-item'>
                    <span className='fas fa-envelope footerInfo-icon'></span>
                    <h4>{polyglot.t('email')}</h4>: <a href='mailto:identity@gunet.gr'>identity@gunet.gr</a>
                </div>
            </span>
            <span className='FooterLeft'>
                <img className='FooterLogo' src={Logo} alt='GUnet Logo'></img>
                <hr className='FooterRuler'/>
                <div id='copyright-tag'>
                    <small><span className='far fa-copyright'></span> 2019 | GUnet</small>
                </div>
            </span>
        </div>)}
  </LanguageConsumer>


export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js